import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ModelsModelService} from '../../../Models/Tasks/Checklists/models-model.service';
import {ModelStoreForm} from '../../../../Models/Tasks/Checklists/Models/model-store.model';
import {FieldModelDto} from '../../../../Models/Tasks/Checklists/Models/model.interface';

@Injectable({
  providedIn: 'root'
})
export class ModelsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ModelsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las plantillas
   *
   */
  public getModels(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getModelos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener detalle plantilla
   *
   */
  getModelDetail(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getModelo', params, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar plantilla
   *
   */
  saveModel(params: ModelStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setModelo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar plantilla
   *
   */
  deleteModel(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteModelo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar campo
   *
   */
  saveField(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setCampo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar campo
   *
   */
  deleteField(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteCampo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar orden de los campos
   *
   */
  saveReorderFields(params: {id_modelo: number, orden: FieldModelDto[]}): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('reorderCampo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
